import {UriPath} from '../uri-path/uri-path';
import {UriParams} from '../uri-params/uri-params';
import {UriHash} from '../uri-hash/uri-hash';
import {Check} from '@sparkware/app-utils';
import {sanitizeUrl} from '../../../../utils/url-utils';

export class Uri {

  constructor(url: URL) {
    this._originalUrl = url;
    this._pathName = new UriPath(this._originalUrl.pathname);
    this._queryParams = new UriParams(this._originalUrl.search);
    this._hash = new UriHash(this._originalUrl.hash);
  }

  private _originalUrl: URL;

  get hostName(): string {
    return this._originalUrl.hostname.toLowerCase();
  }

  get origin(): string {
    return this._originalUrl.origin.toLowerCase();
  }

  private readonly _pathName: UriPath;
  get pathName(): UriPath {
    return this._pathName;
  }

  private readonly _queryParams: UriParams;
  get queryParams(): UriParams {
    return this._queryParams;
  }

  private readonly _hash: UriHash;
  get hash(): UriHash {
    return this._hash;
  }

  toString() {
    let ret:string = sanitizeUrl(this._originalUrl.href);
    return ret;
  }

  equals(theOther: Uri): boolean {
    if(Check.isNullOrUndefined(theOther)) {
      return false;
    }

    return this.origin === theOther.origin
          && this.pathName.equals(theOther.pathName)
          && this.queryParams.equals(theOther.queryParams)
          && this.hash.equals(theOther.hash);
  }

  getUrlWithoutHash() {
    return this._originalUrl.origin + this._originalUrl.pathname + this._originalUrl.search;
  }

  removeSearchParam(paramName: string): Uri {
    let newQueryParams = this.queryParams.removeParam(paramName).toString();
    return new Uri(new URL(this._originalUrl.origin + this._originalUrl.pathname + newQueryParams + this._originalUrl.hash));
  }

  getUrlWithoutSearchAndHash() {
    return this._originalUrl.origin + this._originalUrl.pathname;
  }

  static areEquals(u1: Uri, u2: Uri): boolean {
    if(Check.isNullOrUndefined(u1)) {
      if(Check.isNullOrUndefined(u2)) {
        return true;
      } else {
        return false;
      }
    } else {
      return u1.equals(u2);
    }
  }
}
